
/**
 * UpdateInspecaoPatrimonioItensUseCase
 */

import { IUpdateInspecaoPatrimonioItensUseCase } from "../../../presentation/useCases/update/update_inspecao_patrimonio_itens_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class UpdateInspecaoPatrimonioItensUseCase implements IUpdateInspecaoPatrimonioItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updateInspecaoPatrimonioItens(
    idInspecaoPatrimonioItens: number,
    idInspecaoPatrimonio: number | null,
    ordem: string | null,
    descricao: string | null,
    inspecao1: string | null,
    inspecao2: string | null,
    dataInspecao1: Date | null,
    dataInspecao2: Date | null,
    status: number | null,
  ): Promise<void> {
    await this.repository.updateInspecaoPatrimonioItens(
      idInspecaoPatrimonioItens,
      idInspecaoPatrimonio,
      ordem,
      descricao,
      inspecao1,
      inspecao2,
      dataInspecao1,
      dataInspecao2,
      status,
    );
  }
}
